import { render, staticRenderFns } from "./QuestionAnswerForm.vue?vue&type=template&id=576b7a05&"
import script from "./QuestionAnswerForm.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswerForm.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAnswerForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {LoadingOverlay: require('/lasso/components/LoadingOverlay.vue').default,PropertyAnswerSyncBackModal: require('/lasso/components/properties/PropertyAnswerSyncBackModal.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('576b7a05')) {
      api.createRecord('576b7a05', component.options)
    } else {
      api.reload('576b7a05', component.options)
    }
    module.hot.accept("./QuestionAnswerForm.vue?vue&type=template&id=576b7a05&", function () {
      api.rerender('576b7a05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/questions/QuestionAnswerForm.vue"
export default component.exports